export default __webpack_public_path__ + "static/media/filter_conces.0d9f66e8.svg";